import { createContext, useEffect, useState } from "react";
import { api_url, guest_user } from "../helpers";
import { toast } from "react-toastify";

const userContext = createContext();

function getUserFromLocalStorage() {
  return localStorage.getItem("supplynest")
    ? JSON.parse(localStorage.getItem("supplynest"))
    : guest_user;
}

function UserContext(props) {
  const [user, setUser] = useState(getUserFromLocalStorage());
  const [load, setLoad] = useState(false);
  const [cart, setCart] = useState("");

  async function FetchUserCart() {
    const responsData = await fetch(
      api_url +
        `method/erp_sn.api.mega_menu.get_draft_sales_orders?email=${user?.email}`,
      {
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
        },
      }
    );

    if (responsData.ok == true) {
      const data = await responsData.json();

      if (data?.message?.sales_orders?.length > 0) {
        setCart(data?.message?.sales_orders[0]);
      }
    }
  }

  useEffect(() => {
    if (user?.name) {
      localStorage.setItem("supplynest", JSON.stringify(user));

      if (user?.name != "guest") {
        FetchUserCart();
      }
    }
  }, [user]);

  async function cartUpdate(incoming_data) {

    let items = cart?.items?.length > 0 ? cart?.items : [];

    if (cart?.items?.length > 0) {
      if (incoming_data?.qty == 0) {
        items = items?.filter(
          (prod) => prod?.item_code != incoming_data?.item_code
        );
      } else {
        if (
          items?.filter((prod) => prod?.item_code == incoming_data?.item_code)
            .length > 0
        ) {
          items = items?.map((prod) => {
            if (prod?.item_code == incoming_data?.item_code) {
              return incoming_data;
            } else {
              return prod;
            }
          });
        } else {
          items.push(incoming_data);
        }
      }
    } else {
      items.push(incoming_data);
    }

    let send_data = {
      data: {
        docstatus: 0,
        customer: user?.customer_id,
        order_type: "Shopping Cart",
        transaction_date: "2025-04-12",
        delivery_date: "2025-04-13",
        company: "Supply Nest",
        selling_price_list: "Standard Selling",
        items: items,
      },
    };

    let main_url = api_url + "resource/Sales Order";

    if (cart?.items?.length > 0) {
      main_url = api_url + "resource/Sales Order/" + cart?.sales_order;
    }

    let response = "";

    if (items?.length > 0) {
      response = await fetch(main_url, {
        method: cart?.items?.length > 0 ? "PUT" : "POST",
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(send_data),
      });
    } else {
      response = await fetch(main_url, {
        method: "DELETE",
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
        },
      });
    }

    const data = await response.json();

    if (data?.data?.name || data?.ok) {
      toast.success("Cart Updated");
      FetchUserCart();
    }
  }

  return (
    <userContext.Provider
      value={{ user, setUser, load, setLoad, cart, setCart, cartUpdate }}
    >
      {props?.children}
    </userContext.Provider>
  );
}

export { userContext, UserContext };
